import React from 'react'


const style = {
    color:"#269000",
    fontSize:"2rem",
    fontWeight:600,
    lineHeight:1
}

const CheckMark = () => {
  return (
    <i className={`bx bx-check`} style={style}></i>
  )
}

export default CheckMark